import {CategoriesI18n} from '@/locales/base.message.locales';

export const categories: CategoriesI18n = {
  title: '<p style="font-weight: bold;">CATEGORIAS</p>',
  flag: 'Locais marcados por usuários com um problema relacionado a esta categoria',
  go_to_challenges: 'Ir para os Desafios',
  search: 'Buscar desafio',
  loading: 'Carregando categorias...',
  loading_single: 'Carregando...',
  text: `
     <p class="text-justify">
     Os <span class="primary--text font-weight-bold">Objetivos de Desenvolvimento Sustentável</span> (ODS) são uma coleção de 17 metas globais, parte de um apelo urgente à ação de todos os países - desenvolvidos e em desenvolvimento - em uma parceria global estabelecidas pela ONU na Agenda 2030. Promovemos inovação mapeando projetos e causas que precisam acontecer dentro dessas categorias e temos o compromisso de mobilizar uma rede de talentos locais junto a parcerias globais para realizar, em larga escala e com alto impacto, o que muitos consideram impossível.
     </p>`
};
